import React, { useState } from 'react';
import SyllabusScheduleTable from './SyllabusScheduleTable';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

export default function SyllabusUploadStep2({
  rows,
  onChange,
  onBack,
  onConfirm,
  loading,
  courseId,
  deliveryDay = 'Sunday',
  backLabel = 'Back',
}) {
  const [error, setError] = useState('');

  const handleConfirm = () => {
    // Validation: At least one row must be present
    if (rows.length === 0) {
      setError('Please add at least one lecture week before confirming.');
      return;
    }
    
    // Validation: All rows must have both date and topic
    const hasEmptyRows = rows.some(row => !row.date || !row.topic || row.topic.trim() === '');
    if (hasEmptyRows) {
      setError('Please complete all rows with date and lecture topic before confirming.');
      return;
    }
    
    setError('');
    onConfirm();
  };

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            Confirm your lecture schedule
          </div>
          <p className="syllabus-step-desc">
            {rows.length === 0 
              ? 'Add lecture weeks with dates and topics.'
              : 'Review and edit any dates or topics before confirming.'
            }
          </p>
        </div>
        <div className="section-con">
          {error && (
            <div className="syllabus-error mb-2">{error}</div>
          )}
          <SyllabusScheduleTable 
            rows={rows} 
            onChange={onChange} 
            courseId={courseId}
            deliveryDay={deliveryDay}
          />
        </div>

        <div className="syllabus-step-footer">
          <div />
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <RectangularButton onClick={onBack}>{backLabel}</RectangularButton>
            <RectangularButton
              darkButton
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Confirm schedule'}
            </RectangularButton>
          </div>
        </div>
      </div>
    </div>
  );
}
